import { useIntl } from 'react-intl';

import Heading from '@atlaskit/heading';
import { Stack, Text } from '@atlaskit/primitives';

import { useMigrationTicketsPageAnalytics } from './hooks';
import { messages } from './messages';
import { MigrationTicketsTable } from './migration-tickets-table';

export const FastshiftMigrationTicketsPage = () => {
	const { formatMessage } = useIntl();
	useMigrationTicketsPageAnalytics();

	return (
		<Stack space="space.300">
			<Stack space="space.150">
				<Heading size="large" as="h1">
					{formatMessage(messages.pageTitle)}
				</Heading>
				<Text color="color.text.subtle">{formatMessage(messages.pageDescription)}</Text>
			</Stack>
			<MigrationTicketsTable />
		</Stack>
	);
};
